import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import animeConfig from '../config/animeConfig';
import './Guides.css';

// Data verified via Jikan API (api.jikan.moe/v4/anime/21/characters)
const crew = [
  {
    name: 'Monkey D. Luffy',
    role: 'Captain',
    fruit: 'Gomu Gomu no Mi (revealed as Hito Hito no Mi, Model: Nika)',
    bounty: '3,000,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/9/310307.jpg',
    bio: "Captain of the Straw Hat Pirates. His dream is to find the One Piece and become the Pirate King. Ate a rubber Devil Fruit as a kid, later revealed to be the Hito Hito no Mi, Model: Nika — a Mythical Zoan tied to the Sun God. Despite looking and acting like an idiot most of the time, he is an incredible leader whom the Straw Hats would follow anywhere. His Gear transformations (Second, Third, Fourth, and Fifth from Wano) have defined nearly every major fight in the series."
  },
  {
    name: 'Roronoa Zoro',
    role: 'First Mate / Swordsman',
    fruit: 'No Devil Fruit — Santoryu (Three Sword Style)',
    bounty: '1,111,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/3/100534.jpg',
    bio: "The first member Luffy recruited and the Vice Captain of the crew. Uses three swords at once — one in each hand, one in his mouth. One of the eleven supernova rookies of the Worst Generation. His current blade Enma belonged to Kozuki Oden and drains its wielder's Haki with every swing. His goal is to surpass Dracule Mihawk and become the greatest swordsman alive."
  },
  {
    name: 'Nami',
    role: 'Navigator',
    fruit: 'No Devil Fruit — Clima-Tact weapon',
    bounty: '366,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/6/59914.jpg',
    bio: "The crew's navigator and a skilled cartographer. A lover of money and mikans whose dream is to draw a complete map of the world. Joined after Luffy destroyed Arlong Park and freed her village. Uses a weather-manipulating staff (Clima-Tact) built by Usopp and later upgraded by Franky. Reads ocean currents and sky patterns better than anyone on the Grand Line."
  },
  {
    name: 'Usopp',
    role: 'Sniper',
    fruit: 'No Devil Fruit — Kuro Kabuto slingshot and Pop Greens',
    bounty: '500,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/16/188076.jpg',
    bio: "The crew's sniper, famous for lying constantly. His dream is to become a brave warrior of the sea. Son of Yasopp, a sharpshooter in Shanks's crew. Joined in Syrup Village. Ran from every fight early on but proved himself at Enies Lobby and earned the name \"God Usopp\" at Dressrosa after accidentally rallying the gladiators. His Pop Green ammunition grows into plants on impact."
  },
  {
    name: 'Vinsmoke Sanji',
    role: 'Cook',
    fruit: 'No Devil Fruit — Black Leg Style (kick fighting)',
    bounty: '1,032,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/5/136769.jpg',
    bio: "The crew's cook and a lover of all things women. His dream is to find the All Blue, a legendary ocean where fish from all four seas live. Fights only with his legs to keep his hands safe for cooking. Raised by the pirate chef Zeff at the Baratie after they were stranded together. In the Whole Cake Island arc, his past as a prince of the Vinsmoke Family was revealed — a family of genetically modified assassins he wants nothing to do with."
  },
  {
    name: 'Tony Tony Chopper',
    role: 'Doctor',
    fruit: 'Hito Hito no Mi (Human-Human Fruit)',
    bounty: '1,000',
    image: 'https://cdn.myanimelist.net/images/characters/3/100536.jpg',
    bio: "A reindeer who ate the Human-Human Fruit, which lets him talk and transform. Joined on Drum Island after his mentor Doctor Hiriluk died. Can switch between seven forms using Rumble Balls. His dream is to become a doctor who can cure any disease. The World Government thinks he's the crew's pet, which is why his bounty is a joke — 1,000 berries."
  },
  {
    name: 'Nico Robin',
    role: 'Archaeologist',
    fruit: 'Hana Hana no Mi (Flower-Flower Fruit)',
    bounty: '930,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/16/363700.jpg',
    bio: "The crew's archaeologist and the only person alive who can read Poneglyphs, the ancient stone records that reveal the True History the World Government wants buried. Can sprout copies of her limbs — and after the timeskip, full body doubles — on any surface. Was once an officer in Crocodile's Baroque Works under the name Miss All Sunday. The World Government has hunted her since she was eight years old, when they destroyed her home island of Ohara for researching the Void Century."
  },
  {
    name: 'Franky',
    role: 'Shipwright',
    fruit: 'No Devil Fruit — cola-powered cyborg body',
    bounty: '394,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/13/210053.jpg',
    bio: "Real name Cutty Flam. The crew's shipwright and a self-made cyborg who runs on cola. A former disciple of Tom, the fishman shipwright who built the Oro Jackson — Gol D. Roger's ship — using wood from the Treasure Tree Adam. Franky built the Thousand Sunny from the same wood. Joined after the Enies Lobby arc when the Going Merry could no longer sail."
  },
  {
    name: 'Brook',
    role: 'Musician',
    fruit: 'Yomi Yomi no Mi (Revive-Revive Fruit)',
    bounty: '383,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/10/161005.jpg',
    bio: "\"Soul King\" Brook. A living skeleton and the crew's musician. Ate the Revive-Revive Fruit, which let him come back from death once — but by the time his soul found its body, only bones were left. Spent 50 years alone on a ghost ship in the Florian Triangle before the Straw Hats found him. Also a skilled swordsman who channels his soul's cold through his blade. His dream is to circle the Grand Line and reunite with Laboon, a whale still waiting for him at Reverse Mountain."
  },
  {
    name: 'Jinbe',
    role: 'Helmsman',
    fruit: 'No Devil Fruit — Fish-Man Karate',
    bounty: '1,100,000,000',
    image: 'https://cdn.myanimelist.net/images/characters/15/307148.jpg',
    bio: "A whale shark fish-man and the crew's helmsman. Former Warlord of the Sea and the second captain of the Sun Pirates after Fisher Tiger died. Officially joined Luffy's crew on Whole Cake Island and boarded the ship in Wano. One of the strongest fighters in the crew, and the most level-headed. His Fish-Man Karate lets him control water itself and hit opponents from the inside out."
  }
];

const GuideStrawHatCrew = () => {
  const bgStyle = {
    backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.55), rgba(0, 0, 0, 0.85)), url(${animeConfig.onePiece.backgroundImage})`,
  };

  return (
    <>
      <Helmet>
        <title>The Straw Hat Pirates - Every Crew Member Explained</title>
        <meta name="description" content="All 10 Straw Hat Pirates - Luffy, Zoro, Nami, Usopp, Sanji, Chopper, Robin, Franky, Brook, and Jinbe. Roles, Devil Fruits, and key facts for each." />
        <link rel="canonical" href="https://www.onepiecetrivia.com/guides/straw-hat-crew" />
        <meta property="og:title" content="The Straw Hat Pirates - Every Crew Member Explained" />
        <meta property="og:description" content="All 10 Straw Hat Pirates, their roles, and what makes each one matter to the story." />
        <meta property="og:url" content="https://www.onepiecetrivia.com/guides/straw-hat-crew" />
      </Helmet>

      <div className="guide-page-wrapper" style={bgStyle}>
        <div className="guide-container">
          <h1>The Straw Hat Pirates</h1>
          <p className="guide-intro">
            Luffy's crew, in the order they joined. Ten members total after Jinbe signed on in the Wano arc.
          </p>

          {crew.map((member) => (
            <div className="guide-entry guide-entry-with-image" key={member.name}>
              <img
                src={member.image}
                alt={`${member.name} from One Piece`}
                className="guide-entry-image"
                loading="lazy"
              />
              <div className="guide-entry-body">
                <h3>{member.name} - {member.role}</h3>
                <div className="entry-meta">{member.fruit}</div>
                <div className="entry-bounty">Bounty: {member.bounty} berries</div>
                <p>{member.bio}</p>
              </div>
            </div>
          ))}

          <div className="guide-cta">
            <h2>Think you know the crew?</h2>
            <p>Try the Character Quiz and see how many Straw Hats you can name from their image.</p>
            <Link to="/quiz" className="guide-cta-button">Play the Character Quiz</Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default GuideStrawHatCrew;
